import { FlexCol } from '@components/layout/Flex';
import { styled } from 'goober';

export const DetailContainer = styled('div')(({ theme }) => ({
    border: `1px solid ${theme.colors.neutral.w200}`,
    borderRadius: '8px',
    backgroundColor: theme.colors.ui.white,
    overflow: 'hidden',
}));

export const DetailHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${theme.space.m} ${theme.space.l}`,
    borderBottom: `1px solid ${theme.colors.neutral.w200}`,
    backgroundColor: theme.colors.neutral.w50,
}));

export const CloseButton = styled('button')(({ theme }) => ({
    background: 'none',
    border: 'none',
    fontSize: '18px',
    cursor: 'pointer',
    color: theme.colors.neutral.w500,
    padding: '0 4px',
    lineHeight: 1,
    '&:hover': {
        color: theme.colors.ui.dark,
    },
}));

export const DetailLabel = styled('span')(({ theme }) => ({
    fontSize: '11px',
    color: theme.colors.neutral.w500,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
}));

export const DetailValue = styled('span')(() => ({
    fontSize: '13px',
    fontWeight: 600,
}));

export const DataTableWrapper = styled('div')(({ theme }) => ({
    overflowX: 'auto',
    maxHeight: '400px',
    overflowY: 'auto',
    borderRadius: '6px',
    border: `1px solid ${theme.colors.neutral.w200}`,
}));

export const DataTable = styled('table')(() => ({
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '11px',
    fontFamily: 'monospace',
}));

export const RowNumberTh = styled('th')(({ theme }) => ({
    position: 'sticky',
    top: 0,
    padding: '6px 8px',
    textAlign: 'right',
    backgroundColor: theme.colors.neutral.w100,
    borderBottom: `1px solid ${theme.colors.neutral.w200}`,
    borderRight: `1px solid ${theme.colors.neutral.w200}`,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    color: theme.colors.neutral.w400,
    width: '1px',
}));

export const RowNumberTd = styled('td')(({ theme }) => ({
    padding: '4px 8px',
    textAlign: 'right',
    borderBottom: `1px solid ${theme.colors.neutral.w50}`,
    borderRight: `1px solid ${theme.colors.neutral.w100}`,
    color: theme.colors.neutral.w400,
    fontSize: '10px',
    width: '1px',
    userSelect: 'none',
}));

export const DataTh = styled('th')(({ theme }) => ({
    position: 'sticky',
    top: 0,
    padding: '6px 10px',
    textAlign: 'left',
    backgroundColor: theme.colors.neutral.w100,
    borderBottom: `1px solid ${theme.colors.neutral.w200}`,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    color: theme.colors.neutral.w700,
}));

export const DataTd = styled('td')(({ theme }) => ({
    padding: '4px 10px',
    borderBottom: `1px solid ${theme.colors.neutral.w50}`,
    whiteSpace: 'nowrap',
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.colors.neutral.w700,
}));

export const ShowMoreButton = styled('button')(({ theme }) => ({
    alignSelf: 'center',
    background: 'none',
    border: `1px solid ${theme.colors.neutral.w200}`,
    borderRadius: '6px',
    padding: '6px 16px',
    fontSize: '11px',
    color: theme.colors.primary.w500,
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: theme.colors.primary.w50,
    },
}));

export const NoDataMessage = styled('div')(({ theme }) => ({
    padding: theme.space.m,
    color: theme.colors.neutral.w500,
    fontSize: '12px',
    textAlign: 'center',
}));

export const StepTypeBadge = styled('span')(({ theme }) => ({
    fontSize: '11px',
    padding: '2px 8px',
    borderRadius: '4px',
    backgroundColor: theme.colors.neutral.w100,
    color: theme.colors.neutral.w700,
}));

export const StepDescription = styled('div')(({ theme }) => ({
    padding: '4px 16px 0',
    fontSize: '12px',
    fontStyle: 'italic',
    color: theme.colors.neutral.w600,
}));

export const ErrorMessageBox = styled('div')(({ theme }) => ({
    margin: '0 16px 8px',
    padding: '8px 12px',
    borderRadius: '6px',
    backgroundColor: theme.colors.error.w50,
    border: `1px solid ${theme.colors.error.w100}`,
    fontSize: '12px',
    color: theme.colors.error.w700,
    fontFamily: 'monospace',
}));

export const WarningSection = styled(FlexCol)(({ theme }) => ({
    margin: '0 16px 8px',
    padding: '8px 12px',
    borderRadius: '6px',
    backgroundColor: theme.colors.warning.w50,
    border: `1px solid ${theme.colors.warning.w100}`,
    fontSize: '12px',
    color: theme.colors.warning.w900,
}));

export const WarningSectionHeading = styled('div')(({ theme }) => ({
    fontWeight: 700,
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: theme.colors.warning.w700,
}));

export const WarningEntry = styled(FlexCol)(() => ({
    fontFamily: 'monospace',
}));

export const WarningRuleTag = styled('span')(({ theme }) => ({
    display: 'inline-block',
    fontSize: '10px',
    fontWeight: 700,
    padding: '1px 6px',
    borderRadius: '4px',
    backgroundColor: theme.colors.warning.w100,
    color: theme.colors.warning.w900,
    alignSelf: 'flex-start',
}));

export const SkippedMessageBox = styled('div')(({ theme }) => ({
    margin: '0 16px 8px',
    padding: '8px 12px',
    borderRadius: '6px',
    backgroundColor: theme.colors.neutral.w50,
    border: `1px solid ${theme.colors.neutral.w200}`,
    fontSize: '12px',
    color: theme.colors.neutral.w700,
    fontFamily: 'monospace',
}));

export const DetailSection = styled('div')(() => ({
    padding: '8px 16px 16px',
}));
